import rt from 'vue-routes-generator'
import ConsultasFacturacion from './App'
import PorAgente from './components/porAgente/main'
import PorMeses from './components/porMeses/main'
import PorCliente from './components/porClientes/main'
export default {
	install: Vue => {
		rt.route('/main').child('facturacion', {
			component: ConsultasFacturacion
		})

		rt.route('/main').child('facturacion').child('porAgente', {
			name: 'Consultas por agente',
			component: PorAgente
		})

		rt.route('/main').child('facturacion').child('porMeses', {
			name: 'Consultas por meses',
			component: PorMeses
		})

		rt.route('/main').child('facturacion').child('porClientes', {
			name: 'Consultas por clientes',
			component: PorCliente
		})

		rt.route('/main').child('facturacion').child('', {
			redirect: '/main/facturacion/porAgente'
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/consultas-facturacion/vue/index.js